import React from 'react';
import {MOVIES} from 'api';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import styles from './Search.module.scss';
import { useStore } from 'contexts/store';
import useSearch from '../../hooks/useSearch';
import useClickAway  from 'hooks/useClickAway';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import { SET_SEARCH_MOVIES } from 'constants/store';
import { useHistory } from 'react-router-dom';
import { SET_CURRENT_MOVIE } from 'constants/store';


const Search: React.FC = () : JSX.Element => {
  let { state, dispatch } = useStore();
  const clickRef = React.useRef("");
  const [showSearch, setShowSearch] = React.useState(false);
  let [results, setSearch] = useSearch({ query:'', data: state.movies, keys: ['title', 'isbn', 'author', 'categories'] });
    const history = useHistory();

   useDidMountEffect(() => {
        dispatch({ type:SET_SEARCH_MOVIES, search_movies: results });
        setShowSearch(true)
    }, [results]); 

    useClickAway(clickRef, () => {
      setShowSearch(false)
    });  

   // event listener runs on input change and generate new set of data based on new search query. 
   const handleSearch = (query: any) : void => {
     if(query.length === 0) {
       dispatch({ type:SET_SEARCH_MOVIES, search_movies: MOVIES});
     } else {
       setSearch(query);
     }
   };

    const goTo = (route: string, movie: any) => {
        dispatch({ type:SET_CURRENT_MOVIE,movie:movie });  
        dispatch({ type:SET_SEARCH_MOVIES, search_movies: MOVIES});
        history.push(route);
        window.scrollTo(0, 0);
  };



   const SearchResults = () => {
      return (
        <Paper className={styles.searchResults}>
          {state.search_movies.length > 0 
          ? state.search_movies.map( (movie) => {
             return (
               <div onClick={() => goTo(`/watch/${movie.id}`, movie)} className={styles.searchItem}>
                 <Avatar  
                    src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`} 
                    className={styles.searchImage}
                  />
                 <div className={styles.searchTitle}>{movie.title}</div>
              </div>
             )
          })
          : setShowSearch(false)}
        </Paper>
       )
   };
  
    return (
      <Paper ref={clickRef}  component="div" className={styles.root}>
      <InputBase
        className={styles.input}
        id="search-input"
        placeholder="Search"
        inputProps={{ 'aria-label': 'search movies' }}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={() =>  setShowSearch(true) }
      />
      <IconButton type="submit" className={styles.iconButton} aria-label="search">
        <SearchIcon className={styles.search} />
      </IconButton>
      <Divider className={styles.divider} orientation="vertical" />
      {showSearch && <SearchResults />}
    </Paper>
   );
};

export default Search;